import React, {useState} from 'react'
import { connect } from 'react-redux';
import { toggleDetailsModalAction } from '../../store/actions/resultDetailsActions';
import {queryDetailsAction} from '../../store/actions/searchActions';
import {detailParams, itemInfo, getTextPresentation, normaliseIndexName} from './ResultFunctions';
import NewResultDetails from './NewResultDetails';
import HuzoorQaText from './HuzoorQaText';
import { BEACON_OF_GUIDANCE_INDEX, HOLY_QURAN_INDEX, THIS_WEEK_WITH_HUZOOR_INDEX } from '../../backendInfo';


const ResultItem = ({ resultItem, tab, qtype }) => {

    const [openNewDetails, toggleOpen] = useState(false)
    const indexName = normaliseIndexName(resultItem._index)
    const referencePresentation = getTextPresentation(resultItem._source.lang, indexName)
    
    const handleClick = (e) => {
        toggleOpen(true)
    }

    const subItemInfoStyles = {
        color: 'gray',
        marginTop: '0px',
        marginBottom: '0px',
        paddingBottom: '15px'
    }

    const ItemTextRenderer = props => {
        const { hit } = props
        if ([THIS_WEEK_WITH_HUZOOR_INDEX, BEACON_OF_GUIDANCE_INDEX].includes(indexName)){
            return <div className="snippet">
                <HuzoorQaText hit={hit} onClick={handleClick}/>
            </div>
        }
        if (hit._index !== HOLY_QURAN_INDEX){
            const textPresentation = getTextPresentation(hit._source.lang, indexName)
            return <p 
                    onClick={resultItem => handleClick(resultItem)} 
                    className={`${textPresentation.className} snippet`}
                    dir={textPresentation.dir}
                    lang={textPresentation.lang}
                    dangerouslySetInnerHTML={{__html: hit.highlight['text'][0].replace(/\n/g, '<br>')}}                ></p>
            }
        else{
            const elements = Object.entries(hit.highlight).map(hField => {
                const fieldName = hField[0]
                const infoFieldName = fieldName + '_info'
                const langFieldName = fieldName + '_lang'
                const textPresentation = getTextPresentation(hit._source[langFieldName], HOLY_QURAN_INDEX)
                return <div onClick={handleClick} className="snippet">
                    <p
                    style={{marginBottom:'0', marginTop:'0', paddingTop:'10px'}}
                    className={textPresentation.className}
                    dir={textPresentation.dir}
                    lang={textPresentation.lang}
                    dangerouslySetInnerHTML={{__html: hit.highlight[fieldName]}}
                    ></p>
                    <p
                    style={subItemInfoStyles}
                    className={textPresentation.className}
                    dir={textPresentation.dir}
                    lang={textPresentation.lang}
                    dangerouslySetInnerHTML={{__html: hit._source[infoFieldName]}}
                    ></p>
                </div>               
            })
            return elements
        }
    }
    

    return (
        <div className='result-item hoverable'>
            <ItemTextRenderer hit={resultItem}/>
            
            <div className="reference-info">
            <p
                className={referencePresentation.className}
                dir={referencePresentation.dir}
                lang={referencePresentation.lang}
            >{itemInfo(resultItem._source, indexName)}</p>

            </div>

            {openNewDetails && <NewResultDetails 
                isOpen={openNewDetails} 
                onClose={() => toggleOpen(false)}
                queryParams={detailParams(resultItem._source, indexName, qtype)}
            />}
        </div>
    )
}


const mapDispatchToProps = (dispatch) => {
    return {
        queryDetails: params => dispatch(queryDetailsAction(params)),
        openDetailsModal: () => dispatch(toggleDetailsModalAction(true)),
    }
}

const mapStateToProps = state => {
    return {
        tab: state.filters.tab,
        qtype: state.filters.qtype
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ResultItem);
